import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import WebFont from "webfontloader";
import "../../assets/scss/style.scss";
import dataProvider from "../../components/dataProvider";
import FacebookMasonry from "../../components/FacebookMasonry";
import SlideShow from "../../components/SlideShow";
import ThemeManager from "../../shared/ThemeManager";
import animationControlHelper from "../../shared/utils/animationControlHelper";
import checkScreenLayout from "../../shared/utils/checkScreenLayout";
import checkSupportVideo from "../../shared/utils/checkVideoSupportedPlayback";
import TriggerEvents from "../../shared/utils/trigger.events";

const triggerEvents = TriggerEvents();

function loadScript(url) {
  // 2. This code loads the IFrame Player API code asynchronously.
  let tag = document.createElement("script");
  tag.src = url;
  let firstScriptTag = document.getElementsByTagName("script")[0];

  if (firstScriptTag) {
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  } else {
    document.body.appendChild(tag);
  }
}

let LAYOUT_SECONDARY = "SECONDARY";

let YOUTUBE_FRAME_API_URL = "https://www.youtube.com/iframe_api";
if (!window.YT) {
  loadScript(YOUTUBE_FRAME_API_URL);
}

WebFont.load({
  google: {
    families: ["Lato:300,400,700"]
  }
});

class FacebookSocialApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      youtubeApiLoaded: window.YT !== undefined,
      feed: {},
      pageId: this.getCleanPageId(),
      pageLikesInfo: "",
      preload: Number(this.props.preload) === 1,
      errorMsg: ""
    };

    this.youtubeApiLoadCount = 0;

    if (!this.state.youtubeApiLoaded) {
      window.onYouTubeIframeAPIReady = () => {
        this.setState({ youtubeApiLoaded: true, YT: window.YT });
      };
      this.checkYoutubeApiLoadTimeout();
    }
  }

  getCleanPageId() {
    // pageId will be passed in, user pick a page from their page's admin access list.
    if (this.props.facebook_access) {
      const fbJson = JSON.parse(this.props.facebook_access);
      // console.log('fbJson = ', fbJson)
      if (fbJson && fbJson.selectedPageId) {
        return fbJson.selectedPageId;
      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  handleResize(e) {
    this.setState({ windowWidth: window.innerWidth });
  }

  checkYoutubeApiLoadTimeout() {
    setTimeout(() => {
      if (!this.state.youtubeApiLoaded) {
        this.youtubeApiLoadCount++;
        if (this.youtubeApiLoadCount < 2) {
          loadScript(YOUTUBE_FRAME_API_URL);
          this.checkYoutubeApiLoadTimeout();
        } else {
          // will bypass youtube video object by normal text with detection of winodw.YT = undefined
          this.setState({ youtubeApiLoaded: true });
        }
      } else {
        // console.log('checkYoutubeApiLoadTimeout: YoutubeAPI Loaded')
      }
    }, 15000);
  }

  getProfilePic() {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    let cache_ttl_seconds = this.props.cache_ttl;
    let fetchURL = apiBaseUrl + "/profile_pic";
    let fetchParams = {
      page: this.state.pageId,
      facebook_access: this.props.facebook_access,
      cache_ttl: cache_ttl_seconds
    };
    let maxAgeMinute = cache_ttl_seconds / 60; // this.props.cache_ttl //  // 0.1 // hack for 0.1 ---->  30  // mins

    dataProvider
      .getProfilePic(fetchURL, fetchParams, maxAgeMinute)
      .then(result => {
        console.log("getProfilePic result = ", result);
        if (result === null) {
          throw new Error("Profile not found, skip app");
        }
        // this.updateResultToRender(finalResult)
        this.setState({
          profile: result.req.url
        });
      })
      .catch(error => {
        console.warn(
          "Failed to get data for " + fetchURL + ", params = ",
          fetchParams,
          error
        );
        triggerEvents.sendRenderErrorEvent({
          message:
            "Social Feed for Facebook : Failed to get getProfilePic for " +
            fetchURL +
            ", params = " +
            JSON.stringify(fetchParams),
          error: error
        });
      });
  }

  getLikes() {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    let cache_ttl_seconds = this.props.cache_ttl;
    let fetchURL = apiBaseUrl + "/likes";
    let fetchParams = {
      page: this.state.pageId,
      facebook_access: this.props.facebook_access,
      cache_ttl: cache_ttl_seconds
    };
    let maxAgeMinute = cache_ttl_seconds / 60; // this.props.cache_ttl //  // 0.1 // hack for 0.1 ---->  30  // mins
    // const pageLikesInfo = ''

    dataProvider
      .getPageLikes(fetchURL, fetchParams, maxAgeMinute)
      .then(result => {
        console.log("getPageLikes result = ", result);
        if (result === null) {
          throw new Error("Like not found");
        }
        // this.updateResultToRender(finalResult)
        this.setState({
          pageLikesInfo: result
        });
      })
      .catch(error => {
        console.warn(
          "Failed to get data for " + fetchURL + ", params = ",
          fetchParams,
          error
        );
        // minor error
        triggerEvents.sendRenderErrorEvent({
          message:
            "Social Feed for Facebook : Failed to get getLikes for " +
            fetchURL +
            ", params = " +
            JSON.stringify(fetchParams),
          error: error
        });
      });
  }

  cleanUnsupportedMedia(feed) {
    let mediaType = "";
    let indexToRemove = -1;

    let isSupportMovie = checkSupportVideo.isSupportVideo(this.props);

    for (let index = 0; index < feed.length; index++) {
      let post = feed[index];
      if (
        post.attachments !== "undefined" &&
        post.attachments !== undefined &&
        post.attachments
      ) {
        let attachments = post.attachments.data;
        for (let m = 0; m < attachments.length; m++) {
          let attachment = attachments[m];
          mediaType = attachment.type;
          // laytout type look up for force disable movie
          // let skipVideoPlayback = (this.props.layout === LAYOUT_SECONDARY && (mediaType === 'video_share_highlighted' || mediaType === 'video_inline' || mediaType === 'video_direct_response' || mediaType === 'video_share_youtube'))

          if (
            (isSupportMovie === false &&
              (mediaType === "video_inline" ||
                mediaType === "video_direct_response" ||
                mediaType === "animated_image_video")) ||
            (isSupportMovie === false && mediaType.indexOf("video") !== -1)
          ) {
            indexToRemove = index;
            console.log(
              "REMOVED MEDIA TYPE [index=" + index + "]:",
              mediaType,
              attachment
            );
            break;
          }
        }
      }

      if (indexToRemove !== -1) {
        feed.splice(indexToRemove, 1);
        return this.cleanUnsupportedMedia(feed);
      }
    }

    // Do not display cover_image updates as full slides.
    feed = feed.filter(item => {
      const { attachments } = item;
      if (attachments && attachments.data) {
        let hasInvalidType = false;
        attachments.data.forEach(dataItem => {
          if (dataItem.type === "cover_photo") {
            hasInvalidType = true;
          }
        });
        return !hasInvalidType;
      }

      return true;
    });

    return feed;
  }

  getFeed() {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    let cache_ttl_seconds = this.props.cache_ttl;
    let fetchURL = apiBaseUrl + "/feed";
    let fetchParams = {
      page: this.state.pageId,
      facebook_access: this.props.facebook_access,
      cache_ttl: cache_ttl_seconds
    };
    let maxAgeMinute = cache_ttl_seconds / 60; // this.props.cache_ttl //  // 0.1 // hack for 0.1 ---->  30  // mins
    // const pageLikesInfo = ''
    console.log("getFeed maxAgeMinute = ", fetchParams, maxAgeMinute);

    dataProvider
      .getFeed(fetchURL, fetchParams, maxAgeMinute)
      .then(result => {
        // result = result.slice(15,20)
        console.log("getFeed result = ", result);
        if (result === null) {
          throw new Error("Feed not found");
        }
        // this.updateResultToRender(finalResult)
        this.setState({
          feed: this.cleanUnsupportedMedia(result)
        });
      })
      .catch(error => {
        console.warn(
          "Failed to get data for " + fetchURL + ", params = ",
          fetchParams,
          error
        );

        if (
          error &&
          error.data &&
          error.data.response &&
          error.data.response.text !== ""
        ) {
          try {
            const errorObj = JSON.parse(error.data.response.text);
            console.log("getFeed errorObj = ", errorObj);
            if (
              errorObj &&
              errorObj.error &&
              errorObj.error.message &&
              errorObj.error.message !== ""
            ) {
              if (
                this.state.errorMsg.indexOf("Error validating access token") !==
                  -1 ||
                this.state.errorMsg.indexOf("changed the password") !== -1
              ) {
                triggerEvents.sendAccessDeniedErrorEvent({
                  message: "Social Feed for facebook : " + this.state.errorMsg,
                  user_action_required: true
                });
              }
              this.setState({ errorMsg: errorObj.error.message });
            }
          } catch (e) {
            console.warn("getFeed: Unable to parse error obj: ", error);
          }
        }
        triggerEvents.sendMediaErrorEvent({
          message:
            "Social Feed for Facebook : Failed to get getFeed for " +
            fetchURL +
            ", params = " +
            JSON.stringify(fetchParams),
          error: error
        });
      });
  }

  loadPageData() {
    console.log("-- loadPageData --");
    if (this.state.pageId !== "") {
      this.getLikes();
      this.getProfilePic();
      this.getFeed();
    } else {
      console.warn("Page not found");
    }
  }

  slideshowEndOfSlide() {
    console.log("-- slideshowEndOfSlide --");
    this.loadPageData();
  }

  fixColorCode(color) {
    let hash = color;
    if (hash.indexOf("#") === -1) {
      hash = "#" + color;
    }
    return hash;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextPreload = Number(nextProps.preload) === 1;
    if (
      this.props.preload !== nextProps.preload &&
      this.state.preload !== nextPreload
    ) {
      this.setState({ preload: nextPreload });
      if (nextPreload === true) {
        animationControlHelper.disableAnimation();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => this.handleResize());
  }

  initIntercom() {
    triggerEvents.on("start", () => {
      this.setState({ preload: false });
    });
    triggerEvents.on("finish", () => {
      triggerEvents.sendFinishedEvent({ title: "Social Feed for Facebook" });
    });
  }

  componentDidMount() {
    this.initIntercom();
    if (this.state.preload === true) {
      animationControlHelper.disableAnimation();
    }

    window.addEventListener("resize", () => this.handleResize());
    this.setState({ pageId: this.getCleanPageId() });
    this.loadPageData();
  }

  render() {
    let screenLayout = checkScreenLayout.getLayout();

    if (screenLayout === "tickertape") {
      if (this.skipAppTimer) {
        clearTimeout(this.skipAppTimer);
        this.skipAppTimer = null;
      }
      // showing error message for 10 seconds then skip to next app in the playlist
      this.skipAppTimer = setTimeout(() => {
        console.log("skip to next app");
        triggerEvents.sendFinishedEvent({ title: "Social Feed for Facebook" });
      }, 10000);

      return (
        <div className="warning-message">
          <span>
            Social Feed App cannot be supported in this zone or layout.
          </span>
        </div>
      );
    } else {
      if (this.skipAppTimer) {
        clearTimeout(this.skipAppTimer);
        this.skipAppTimer = null;
      }
    }

    let feed = this.state.feed;
    let pageLikesInfo = this.state.pageLikesInfo;
    let fullscreen = this.props.fullscreen;
    let pageName = "";
    let shortName = "";
    let contentLayout = "";
    let endOffSlideCallBack = () => this.slideshowEndOfSlide();

    let errorMsg = "";

    if (
      this.state.errorMsg.indexOf("Error validating access token") !== -1 ||
      this.state.errorMsg.indexOf("changed the password") !== -1
    ) {
      errorMsg = (
        <div className="errorMsg">
          Please return to Signage to edit the app or create a new one by
          logging in to your Facebook account again using your most up to date
          username and password.
        </div>
      );
    } else if (!this.state.preload && this.state.errorMsg !== "") {
      errorMsg = <div className="errorMsg">{this.state.errorMsg}</div>;
    }

    // console.log('render facebook-feed', feed)
    let slideshowContainerStyle;

    if (
      typeof this.props.theme !== "undefined" &&
      this.props.theme.length !== 0 &&
      this.props.theme !== "default"
    ) {
      slideshowContainerStyle = { backgroundColor: "#e8ebee" };
    }

    // Preload
    if (!this.state.preload) {
      if (!feed || !feed.length || !this.state.youtubeApiLoaded) {
        document.body.classList.add("slide-preload", "color-bg-primary");
        return (
          <ThemeManager theme={this.props.theme}>
            <div
              className="slideshow-container"
              style={slideshowContainerStyle}
            >
              <span className="load-message" />
              {errorMsg}
            </div>
          </ThemeManager>
        );
      } else {
        document.body.classList.remove("slide-preload");
      }
    }

    // Get page name
    if (
      pageLikesInfo &&
      pageLikesInfo !== "" &&
      typeof pageLikesInfo.link !== "undefined"
    ) {
      // console.log('pageLikesInfo = ', pageLikesInfo)
      pageName = pageLikesInfo.name;
      shortName = pageLikesInfo.link.match(/([^/]*)\/*$/)[1];
    } else {
      console.warn("pageLikesInfo missing: ", pageLikesInfo);
    }

    let layoutName = "layout-" + screenLayout;

    if (layoutName === "layout-tickertape") {
      return (
        <div className="warning-message">
          <span>
            Page Likes app cannot be supported in this zone or layout.
          </span>
        </div>
      );
    }

    // Custom Color
    let appStyle = {};

    // Backward compatable
    if (this.props.bgcolor && this.props.color) {
      // console.log('Custom Theme!!')
      appStyle = {
        background: this.fixColorCode(this.props.bgcolor)
      };
    }

    // Switch Layout
    switch (this.props.layout) {
      case "masonry":
        contentLayout = (
          <div>
            <header>
              <h1>{pageName}</h1>
            </header>
            <main>
              <FacebookMasonry
                profilePic={this.state.profile}
                name={pageName}
                shortName={shortName}
                items={feed}
                color={this.props.color}
                bgColor={this.props.bgcolor}
              />
            </main>
          </div>
        );
        break;
      default:
        contentLayout = (
          <div className="slideshow" style={appStyle}>
            <main style={appStyle}>
              <SlideShow
                items={feed}
                profilePic={this.state.profile}
                name={pageName}
                shortName={shortName}
                pageLikesInfo={pageLikesInfo}
                delay={this.props.delay}
                fullscreen={this.props.fullscreen}
                endOfSlidesCallback={endOffSlideCallBack}
                max_play_durations={this.props.max_play_durations}
                bgColor={this.props.bgcolor}
                color={this.props.color}
                preload={this.state.preload}
                facebook_access={this.props.facebook_access}
                theme={this.props.theme}
                displayQr={this.props.qr_code === "true" ? true : false}
                mute={this.props.mute === "true" ? true : false}
              />
            </main>
          </div>
        );
    }

    if (
      this.state.preload === true &&
      this.state.feed &&
      this.state.feed.length > 0
    ) {
      if (!this.isAppPreloaded) {
        this.isAppPreloaded = true;
        triggerEvents.sendAppStatusPreloaded({
          title: "Social Feed for Facebook : " + pageName,
          url: ""
        });
      }
    } else if (!this.state.preload && !this.isAppStarted) {
      this.isAppStarted = true;
      animationControlHelper.enableAnimation();
      triggerEvents.sendAppStatusStarted({
        duration: this.props.duration || "",
        title: "Social Feed for Facebook : " + pageName,
        url: this.state.profile
      });
    }

    let layoutClass = classNames({
      [`layout-${screenLayout}`]: true,
      preloadState:
        this.state.preload && this.state.feed && this.state.feed.length > 0,
      "layout-card": fullscreen === "false",
      "layout-fullscreen": fullscreen !== "false",
      [this.props.layout]: this.props.layout !== undefined,
      [layoutName]: true,
      secondary: this.props.layout === LAYOUT_SECONDARY,
      "color-bg-primary": true,
      "custom-theme":
        typeof this.props.theme !== "undefined" &&
        this.props.theme.length !== 0 &&
        this.props.theme !== "default"
    });

    console.log(
      "RENDER: this.state.preload = " +
        this.state.preload +
        "  layoutClass = " +
        layoutClass
    );

    return (
      <ThemeManager theme={this.props.theme}>
        <div id="app" className={layoutClass}>
          {contentLayout}
        </div>
      </ThemeManager>
    );
  }
}

// Properties are parsed directly from query string, so all are strings.
FacebookSocialApp.propTypes = {
  preload: PropTypes.string,
  facebook_access: PropTypes.string,
  cache_ttl: PropTypes.number,
  server: PropTypes.string,
  layout: PropTypes.string,
  fullscreen: PropTypes.string,
  theme: PropTypes.string,
  bgcolor: PropTypes.string,
  color: PropTypes.string,
  delay: PropTypes.number,
  max_play_durations: PropTypes.number,
  qr_code: PropTypes.string,
  mute: PropTypes.string,
  duration: PropTypes.string
};

FacebookSocialApp.defaultProps = {
  max_play_durations: 15, // minutes, pass through YoutubePlayer
  delay: 20,
  // bgcolor: '#3B5998',
  // color: '#FFFFFF',
  fullscreen: "true",
  cache_ttl: 5 * 60
};

export default FacebookSocialApp;
